<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label">Hoteles / Empresas:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.IdAgente" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Agentes" :key="ind" :value="item.IdAgente">{{item.NombreComercial}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label for="">Por Meses</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.Mes" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Meses" :key="ind" :value="item.Value">{{item.Tag}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.Anio" class="form-select form-control-search">
                        <option v-for="(item,ind) in Anios" :key="ind" :value="item">{{item}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label for="">o Por Rangos</label>
                </div>
                <div class="col-auto">
                    <Datepicker @input="GetDatosGrafica" v-model="Filtro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
                </div>
                <div class="col-auto">
                    <Datepicker @input="GetDatosGrafica" v-model="Filtro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Final"></Datepicker>
                </div>
                <div class="col-auto">
                    <button @click="BorrarFechas" class="btn btn-primary"><i class="fa fa-trash"></i> Fechas</button>
                </div>
            </template>

            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-secondary h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-tags"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Cotizaciones Autorizadas
                                            <br>
                                            $ {{ MontoCotizacionesAutorizadas }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ CotizacionesAutorizadas }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-info h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-file-text"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Facturas / Notas de Venta Emitidas
                                            <br>
                                            $ {{ MontoFacturaNotaEmitidas }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span class="d-flex align-items-center" style="flex-flow:row wrap;float:right; width:150px">
                                            Facturas:
                                            <div class="circNum">
                                                <p>{{ FacturasEmitidas }}</p>
                                            </div>
                                            Notas:
                                            <div class="circNum">
                                                <p>{{ NotasEmitidas }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-success h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-file-invoice-dollar"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Facturas / Notas de Venta Cobradas
                                            <br>
                                            $ {{ MontoFacturaNotaCobradas }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span class="d-flex align-items-center" style="flex-flow:row wrap;float:right; width:150px">
                                            Facturas:
                                            <div class="circNum">
                                                <p>{{ FacturasCobradas }}</p>
                                            </div>
                                            Notas:
                                            <div class="circNum">
                                                <p>{{ NotasCobradas }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-danger h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-donate"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Facturas / Notas de Venta Por Cobrar
                                            <br>
                                            $ {{ MontoFacturaNotaPorCobrar }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span class="d-flex align-items-center" style="flex-flow:row wrap;float:right; width:150px">
                                            Facturas:
                                            <div class="circNum">
                                                <p>{{ FacturasPorCobrar }}</p>
                                            </div>
                                            Notas:
                                            <div class="circNum">
                                                <p>{{ NotasPorCobrar }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div id="GraficaMonto">
                                    <apexchart :height="GraficaMontoCotizaciones.chartOptions.chart.height" :type="GraficaMontoCotizaciones.chartOptions.chart.type" :options="GraficaMontoCotizaciones.chartOptions" :series="GraficaMontoCotizaciones.series"></apexchart>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-warning h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-hand-holding-usd"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Descuentos
                                            <br>
                                            $ {{ MontoDescuentos }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span class="d-flex align-items-center" style="flex-flow:row wrap;float:right; width:150px">
                                            Facturas:
                                            <div class="circNum">
                                                <p>{{ FacturasDescuento }}</p>
                                            </div>
                                            Notas:
                                            <div class="circNum">
                                                <p>{{ NotasDescuento }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-primary h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-award"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Florería
                                            <br>
                                            $ {{ MontoFloreria }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ CantidadFloreria }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-info h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-handshake"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Montaje
                                            <br>
                                            $ {{ MontoMontaje }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Total</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ CantidadMontaje }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div id="GraficaDescuento">
                                    <apexchart :height="GraficaDescuentos.chartOptions.chart.height" :type="GraficaDescuentos.chartOptions.chart.type" :options="GraficaDescuentos.chartOptions" :series="GraficaDescuentos.series"></apexchart>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div id="GraficaDescuento">
                                    <apexchart :height="GraficaElementosFacturados.chartOptions.chart.height" :type="GraficaElementosFacturados.chartOptions.chart.type" :options="GraficaElementosFacturados.chartOptions" :series="GraficaElementosFacturados.series"></apexchart>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div id="GraficaProductosServicios">
                                    <apexchart :height="GraficaProductosServicios.chartOptions.chart.height" :type="GraficaProductosServicios.chartOptions.chart.type" :options="GraficaProductosServicios.chartOptions" :series="GraficaProductosServicios.series"></apexchart>
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
            </template>

        </CList>
    </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta='seccionReporteVentas';
export default {
    name:"ReporteVenta",
    data() {
        return {
            ConfigList:{
                Title:'Reporte de Ventas',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowPaginador: false,
                ShowSearch:false,
                ShowEntradas:false,
                TypeBody: 'Form',
				TitleFirst: 'Finanzas',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            Filtro:{
                IdAgente:'',
                Mes:'',
                Anio:new Date().getFullYear(),
                // Anio:'2023',
                Inicio:'',
                Fin:''
            },
            segurity:{},
            Setpicker:Calendar.calendarSettings,
            Agentes:[],
            Meses:[
                {Tag:"Enero",Value:"1"},
                {Tag:"Febrero",Value:"2"},
                {Tag:"Marzo",Value:"3"},
                {Tag:"Abril",Value:"4"},
                {Tag:"Mayo",Value:"5"},
                {Tag:"Junio",Value:"6"},
                {Tag:"Julio",Value:"7"},
                {Tag:"Agosto",Value:"8"},
                {Tag:"Septiembre",Value:"9"},
                {Tag:"Octubre",Value:"10"},
                {Tag:"Noviembre",Value:"11"},
                {Tag:"Diciembre",Value:"12"}
            ],
            Anios:[],
            MontoCotizacionesAutorizadas:0,
            CotizacionesAutorizadas:0,
            MontoFacturaNotaEmitidas:0,
            FacturasEmitidas:0,
            NotasEmitidas:0,
            MontoFacturaNotaCobradas:0,
            FacturasCobradas:0,
            NotasCobradas:0,
            MontoFacturaNotaPorCobrar:0,
            FacturasPorCobrar:0,
            NotasPorCobrar:0,
            MontoDescuentos:0,
            FacturasDescuento:0,
            NotasDescuento:0,
            MontoFloreria:0,
            CantidadFloreria:0,
            MontoMontaje:0,
            CantidadMontaje:0,
            GraficaMontoCotizaciones:{
                chartOptions:{
                    chart:{
                        type:'bar',
                        height:"350",
                    },
                    title:{
                        text:'Monto de Cotizazciones',
                        align:"center"
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    xaxis: {
                        categories: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
                    },
                    yaxis:{
                        labels:{
                            formatter:(num)=>{
                                let fixed = 0;
                                if (num === null) { return null; } // terminate early
                                if (num === 0) { return '0'; } // terminate early
                                fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
                                const b = (num).toPrecision(2).split("e"), // get power
                                    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
                                    c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
                                    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
                                    e = d + ['', ' K', ' M', ' B', ' T'][k]; // append power
                                return e;
                            }
                        },
                        title:{
                            text:'Montos $'
                        }
                    },
                    dataLabels:{
                        enabled:false
                    },
                    colors: ['#8392AB', '#11CDEF', '#2DCE89', '#F5365C'],
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                },
                series:[]
            },
            GraficaDescuentos:{
                chartOptions:{
                    chart:{
                        type:'bar',
                        height:"400",
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 10,
                            dataLabels: {
                                position: 'top',
                            },
                        }
                    },
                    yaxis:{
                        labels:{
                            formatter:(num)=>{
                                let fixed = 0;
                                if (num === null) { return null; } // terminate early
                                if (num === 0) { return '0'; } // terminate early
                                fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
                                const b = (num).toPrecision(2).split("e"), // get power
                                    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
                                    c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
                                    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
                                    e = d + ['', ' K', ' M', ' B', ' T'][k]; // append power
                                return e;
                            }
                        },
                    },
                    title:{
                        text:'Descuentos en Facturación del Año',
                        align:"center"
                    },
                    xaxis: {
                        categories: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
                    },
                    colors:["#71C6FF","#71FECC","#FDE376","#FF6178","#7865BA","#6C848E","#46B3A9","#D10CE8","#D10CE8","#D10CE8","#D10CE8","#D10CE8"],
                    dataLabels:{
                        enabled:true,
                        offsetY:-2,
                        style:{
                            colors:["#000"]
                        }
                    },
                },
                series:[]
            },
            GraficaElementosFacturados:{
                chartOptions:{
                    chart:{
                        type:'line',
                        height:'400'
                    },
                    stroke:{
                        curve:'smooth',
                        width:2
                    },
                    xaxis:{
                        categories:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
                    },
                    yaxis:{
                        labels:{
                            formatter:(val)=>{
                                return val.toFixed(0);
                            }
                        },
                        title:{
                            text:'Cantidad'
                        }
                    },
                    dataLabels:{
                        enabled:true,
                        background:{
                            borderRadius:10
                        }
                    },
                    fill:{
                        colors:['#3B97B2']
                    },
                    colors:['#5E72E4','#11CDEF'],
                    title: {
                        text: 'Elementos Facturados',
                        align: 'center'
                    },
                },
                series:[]
            },
            GraficaProductosServicios:{
                chartOptions:{
                    chart:{
                        type:'area',
                        height:'350',
                        stacked:true
                    },
                    title:{
                        text:'Clave de Productos / Servicios Facturados',
                        align:"center"
                    },
                    xaxis: {
                        categories: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
                    },
                    yaxis:{
                        title:{
                            text:'Cantidad'
                        }
                    },
                },
                series:[]
            }
        }
    },
    methods: {
        async GetDatosGrafica(){
            this.ConfigLoad.ShowLoader=true;
            this.GraficaDescuentos.series=[];
            let FechaInicio='';
            let FechaFin='';
            if (this.Filtro.Inicio!='') {
                let YearInicio=this.Filtro.Inicio.getFullYear();
                let MonthInicio=this.Filtro.Inicio.getMonth()+1;
                let DayInicio=this.Filtro.Inicio.getDate();
                FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
            }
            if (this.Filtro.Fin!='') {
                let YearFin=this.Filtro.Fin.getFullYear();
                let MonthFin=this.Filtro.Fin.getMonth()+1;
                let DayFin=this.Filtro.Fin.getDate();
                FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
            }

            await this.$http.get('reporteVentas',{
                params:{
                    IdAgente:this.Filtro.IdAgente,
                    Mes:this.Filtro.Mes,
                    Anio:this.Filtro.Anio,
                    Inicio:FechaInicio,
                    Fin:FechaFin
                }
            }).then((res)=>{
                this.CotizacionesAutorizadas=res.data.data.CotizacionesAutorizadas;
                this.MontoCotizacionesAutorizadas=res.data.data.MontoCotizacionesAutorizadas;
                this.MontoFacturaNotaEmitidas=res.data.data.MontoFacturaNotaEmitidas;
                this.FacturasEmitidas=res.data.data.FacturasEmitidas;
                this.NotasEmitidas=res.data.data.NotasEmitidas;
                this.MontoFacturaNotaCobradas=res.data.data.MontoFacturaNotaCobradas;
                this.FacturasCobradas=res.data.data.FacturasCobradas;
                this.NotasCobradas=res.data.data.NotasCobradas;
                this.MontoFacturaNotaPorCobrar=res.data.data.MontoFacturaNotaPorCobrar;
                this.FacturasPorCobrar=res.data.data.FacturasPorCobrar;
                this.NotasPorCobrar=res.data.data.NotasPorCobrar;
                this.MontoDescuentos=res.data.data.MontoDescuentos;
                this.FacturasDescuento=res.data.data.FacturasDescuento;
                this.NotasDescuento=res.data.data.NotasDescuento;
                this.MontoFloreria=res.data.data.MontoFloreria;
                this.CantidadFloreria=res.data.data.CantidadFloreria;
                this.MontoMontaje=res.data.data.MontoMontaje;
                this.CantidadMontaje=res.data.data.CantidadMontaje;

                this.GraficaMontoCotizaciones.series=res.data.data.GraficaCotizaciones.Elements;
                console.log(res.data.data.GraficaCotizaciones.Elements)
                if (this.GraficaDescuentos.series.lenght>0) {
                    this.GraficaDescuentos.series[0].data=res.data.data.GraficaDescuentos.Values;
                }
                else{
                    this.GraficaDescuentos.series.push({name:"Monto Descuento",data:res.data.data.GraficaDescuentos.Values});
                }
                this.GraficaElementosFacturados.series=res.data.data.GraficaElementosFacturados;

                this.GraficaProductosServicios.series=res.data.data.GraficaProductosServicios.Elements;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
        BorrarFechas(){
            this.Filtro.Inicio='';
            this.Filtro.Fin='';
            this.GetDatosGrafica();
        },
        GetFiltros(){
            this.$http.get('finanzasGraficasFiltros',{
                params:{
                    Anio:new Date().getFullYear(),
                }
            }).then((res)=>{
                this.Agentes=res.data.data.Agentes;
                this.Anios=res.data.data.Anios;
                this.Anios.push(new Date().getFullYear());
            })
        }
    },
    created() {
        
    },
    mounted() {
        this.GetFiltros();
        this.GetDatosGrafica();
    },
}
</script>

<style>

</style>